import {ManagementTransformBase} from "../TranformBase";

import {
  ActionCreateModel,
  ActionRecordModel,
  ActionUpdateModel,
} from "@/api/models";
import {Action} from "@/api/services";

export abstract class ActionsTransform<
  R extends ActionRecordModel,
  C extends ActionCreateModel,
  U extends ActionUpdateModel,
> extends ManagementTransformBase<R> {
  abstract makeRecordModel(dto: Action): R;

  abstract makeCreateDto(model: C): Action;

  abstract makeUpdateDto(model: U): Partial<Action>;
}
